import {Link, Text} from '@constellation/core';
import {Fragment, memo} from 'react';
import breakPoint from '../../../../../utils/breakPoint.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import {
  FootnotesDiv,
  FootnotesListItem,
  FootnotesListItemNo,
} from '../Styles/Styles.js';

const Footnotes = memo(() => (
  <Fragment>
    {getPsrLabel('cardPaymentServicesDetails.footnotes').map((note, index) => (
      <FootnotesDiv id={note.id} key={note.id}>
        <FootnotesListItemNo>
          <Text>{index + 1}.</Text>
        </FootnotesListItemNo>
        <FootnotesListItem>
          <Text>
            {note.description}
            <Link
              aria-label={`${getPsrLabel(
                'cardPaymentServicesDetails.backToContent'
              )} ${index + 1}`}
              href={`#${note.refid}${breakPoint}`}
            >
              ↩
            </Link>
          </Text>
        </FootnotesListItem>
      </FootnotesDiv>
    ))}
  </Fragment>
));

export default Footnotes;
